<template>
    <div>
        <v-progress-circular
					class="text-xs-center"
            :rotate="270"
            :size="28"
            :width="14"
            :value="value"
            color="secondary"
        >
            <span class="body-1 timer-text white--text">{{ second }}</span>
        </v-progress-circular>
    </div>
</template>

<script>
function second() {
	return this.value / 20;
}

export default {
	name: 'countdown',
	computed: {
		second,
	},
	props: {
		value: {
			default: 100,
			type: Number,
		},
	},
};
</script>

<style lang="scss" scoped>
	.timer-text {
		font-family: map-get($fonts, bold);
	}

	.v-progress-circular {
		transform: rotateY(180deg);

		span {
			display: block;
			transform: rotateY(-180deg) translate(-2%, -2%);
			zoom: 1.1;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/shared/countdown.vue